import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { SidebarItem } from '@backstage/core-components';
import { usePermission } from '@backstage/plugin-permission-react';
import {
  llmProxyAppsKeyReadPermission,
  llmProxyAppsVirtualKeysPath,
  llmProxyLocaldevKeyReadPermission,
  llmProxyLocaldevVirtualKeysPath,
} from '@internal/plugin-llm-proxy-keys-common';
import { useLlmProxyKeysConfig } from '@internal/plugin-llm-proxy-keys';

export const LlmProxySidebarItems = () => {
  const { config } = useLlmProxyKeysConfig();
  const { allowed: localdevAllowed } = usePermission({
    permission: llmProxyLocaldevKeyReadPermission,
  });
  const { allowed: appsAllowed } = usePermission({
    permission: llmProxyAppsKeyReadPermission,
  });

  if (!config?.enabled || (!localdevAllowed && !appsAllowed)) {
    return null;
  }

  const to = localdevAllowed
    ? llmProxyLocaldevVirtualKeysPath
    : llmProxyAppsVirtualKeysPath;

  return (
    <SidebarItem icon={VpnKeyIcon} to={to} text="LLM Proxy Keys" />
  );
};
